import { compose } from 'recompose'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import { getPageLocation } from 'selectors'
import { SERVICES_PAGE } from 'constant'
import BOTServiceCategories from './BOTServiceCategories'

const mapStateToProps = state => {
  const location = getPageLocation(state)
  const isServicesPage = location.pathname.startsWith(SERVICES_PAGE)

  return {
    isServicesPage
  }
}

export default compose(
  withType({ type: 'BOTServiceCategories' }),
  connect(mapStateToProps)
)(BOTServiceCategories)
